var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-row",
        { staticClass: "tabs-demo__size" },
        [
          _c(
            "v-col",
            { attrs: { span: 22 } },
            [
              _c(
                "v-tabs",
                {
                  attrs: { size: "S", name: "tabs-s-card", type: "button" },
                  model: {
                    value: _vm.activeNamebutton,
                    callback: function ($$v) {
                      _vm.activeNamebutton = $$v
                    },
                    expression: "activeNamebutton",
                  },
                },
                [
                  _c(
                    "v-tab-pane",
                    { attrs: { label: "运行状态", value: "1" } },
                    [_c("RunStatus", { attrs: { devKey: _vm.devKey } })],
                    1
                  ),
                  _c(
                    "v-tab-pane",
                    { attrs: { label: "事件管理", value: "2" } },
                    [_c("EventManage", { attrs: { devKey: _vm.devKey } })],
                    1
                  ),
                  _c(
                    "v-tab-pane",
                    { attrs: { label: "服务调用", value: "3" } },
                    [_c("ServeCall", { attrs: { devKey: _vm.devKey } })],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }